// extracted by mini-css-extract-plugin
export default {"RatingProgressBar":"RatingProgressBar_RatingProgressBar__h9THv","progress-bar":"RatingProgressBar_progress-bar__EdqHu"};